var React = require('react');

function Copy (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"copy","transform":"translate(-728 -440)"},[React.createElement("rect",{"id":"nền_20x20","data-name":"nền 20x20","width":"24","height":"24","transform":"translate(728 440)","fill":"#fff","key":0}),React.createElement("path",{"id":"copy-2","data-name":"copy","d":"M197.1,260.461a1.7,1.7,0,0,1-1.719-1.719V244.957h1v13.784a.779.779,0,0,0,.724.724h10.169v1Zm3.167-3.167a1.7,1.7,0,0,1-1.719-1.719V242.18a1.7,1.7,0,0,1,1.719-1.719h9.864a1.7,1.7,0,0,1,1.719,1.719v13.394a1.7,1.7,0,0,1-1.719,1.719Zm0-1h9.864a.779.779,0,0,0,.724-.724V242.18a.779.779,0,0,0-.724-.724h-9.864a.779.779,0,0,0-.724.724v13.394a.779.779,0,0,0,.724.724Zm-.724,0v0Z","transform":"translate(536.616 201.539)","fill":"#686868","key":1})]));
}

Copy.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Copy;

Copy.default = Copy;
